// extracted by mini-css-extract-plugin
export default {"-large":"E1ppjl4cYx9cQ6u5jFwm","container":"QjOFy7uHFH0c5cAQBVVq","prompt":"P7MeWR4Y9bPXs6sfryGD"};